// Navbar.js
import './Navbar.css';
import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Dropdown from './Dropdown';
import { performanceMenuItems, serviceMenuItems } from './MenuItems';

export const Navbar = () => {
	const location = useLocation();
	const isServicesPath = location.pathname.includes('/services/');
	const isPerformancesPath = location.pathname.includes('/performances/');
	const [menuOpen, setMenuOpen] = useState(false);
	const [activeDropdown, setActiveDropdown] = useState(null);

	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
		setActiveDropdown(null);
	};

	const showDropdownOnHover = (menuName) => {
		setActiveDropdown(menuName);
	};

	const hideDropdownOnLeave = () => {
		setActiveDropdown(null);
	};

	const closeMenu = () => {
		setMenuOpen(false);
		setActiveDropdown(null);
	};

	return (
		<nav className='main-nav' onMouseLeave={hideDropdownOnLeave}>
			<div className='burger-wrapper'>
				<button
					className={`burger ${menuOpen ? 'open' : ''}`}
					onClick={toggleMenu}
				>
					<span className='burger-menu'></span>
					<span className='burger-menu'></span>
					<span className='burger-menu'></span>
				</button>
			</div>
			<ul className={`main-menu ${menuOpen ? 'open' : ''}`}>
				<li className='main-menu-item'>
					<NavLink
						className='main-menu-item-link'
						to='/about'
						onClick={closeMenu}
					>
						About
					</NavLink>
				</li>
				<li
					className='main-menu-item'
					onMouseEnter={() => showDropdownOnHover('services')}
				>
					<NavLink
						className='main-menu-item-link'
						to='/services'
						onClick={closeMenu}
					>
						Services
					</NavLink>
					{(isServicesPath || activeDropdown === 'services') && (
						<Dropdown items={serviceMenuItems} onItemClick={closeMenu} />
					)}
				</li>
				<li
					className='main-menu-item'
					onMouseEnter={() => showDropdownOnHover('performances')}
				>
					<NavLink
						className='main-menu-item-link'
						to='/performances'
						onClick={closeMenu}
					>
						Performances
					</NavLink>
					{(isPerformancesPath || activeDropdown === 'performances') && (
						<Dropdown items={performanceMenuItems} onItemClick={closeMenu} />
					)}
				</li>
				<li className='main-menu-item'>
					<NavLink
						className='main-menu-item-link'
						to='/testimonials'
						onClick={closeMenu}
					>
						Testimonials
					</NavLink>
				</li>
				<li className='main-menu-item'>
					<NavLink
						className='main-menu-item-link'
						to='/gallery'
						onClick={closeMenu}
					>
						Gallery
					</NavLink>
				</li>
				<li className='main-menu-item'>
					<NavLink
						className='main-menu-item-link'
						to='/contact'
						onClick={closeMenu}
					>
						Contact
					</NavLink>
				</li>
			</ul>
		</nav>
	);
};

export default Navbar;
